<template>
    <div class="container">
        <span class="title">{{title}}</span>
        <img :src="getIcon" @click="remove" class="icon" alt="Remove File" />
    </div>
</template>

<script lang='ts'>
import { defineComponent } from 'vue';

export default defineComponent({
    props: {
        title: {type: String, required: true},
    },
    computed:{
        getIcon() {
            return require('@/assets/img/close-circle.svg');
        }
    },
    methods: {
        remove() {
            this.$emit('remove');
        }
    }
});
</script>

<style scoped>
.container{
    display: flex;
    align-items: center;
    border: 1px solid var(--background-color-disabled);
    border-radius: 12px;
    height: 24px;
    color: var(--black);
    padding: 0px 8px 0px 12px;
}
.icon{
    height: 18px;
    margin: 0 0 0 6px;
    cursor: pointer;
}
</style>
